import { LogComponentCreator } from '@/ui/components/activityLogs/factory/LogComponentCreator';
import { LogEntityComponent } from '@/ui/components/activityLogs/factory/LogEntityComponent';
import { LogIssueComponent } from '@/ui/components/activityLogs/factory/LogIssueComponent';

export class LogIssueCreator extends LogComponentCreator {
  // eslint-disable-next-line class-methods-use-this
  public componentFactory(): LogEntityComponent {
    return new LogIssueComponent();
  }
}
